import { Card, Stack } from '@mui/material'
import { memo } from 'react'

import { SOCIAL_MEDIA } from 'src/constants/app'
import { FacebookIcon, GoogleIcon } from '../../assets/icons/social-icons'
import { LABEL_TEXT } from '../../constants/messages'
import { titleCase } from '../../util/string.helpers'
import Button from '../shared/button/Button'
import CustomTextField from '../shared/inputs/CustomTextField'
import CardHeading from '../shared/text/CardHeading'

const DisplayEmailAddress = ({ email, signedUpVia, t }) => {
  return (
    <Card
      sx={{
        p: 3
      }}
    >
      <CardHeading
        title={t('user-account.logged-in-with', {
          provider: titleCase(signedUpVia)
        })}
      />
      <CustomTextField
        label={t('common.email-address')}
        value={email}
        disabled
      />
      <Stack spacing={3} sx={{ mt: 3, alignItems: 'flex-end' }}>
        <SocialMediaButton
          disabled
          type={signedUpVia}
          label={LABEL_TEXT.SIGNUP}
        />
      </Stack>
    </Card>
  )
}

export default memo(DisplayEmailAddress)

const SocialMediaButton = ({ type, label, disabled, ...restProps }) => {
  switch (type) {
    case SOCIAL_MEDIA.FACEBOOK:
      return (
        <Button
          disabled={disabled}
          label={
            <>
              <FacebookIcon width={22} sx={{ mr: 1 }} /> {label}
            </>
          }
        />
      )
    case SOCIAL_MEDIA.GOOGLE:
      return (
        <Button
          disabled={disabled}
          label={
            <>
              <GoogleIcon width={22} sx={{ mr: 1 }} /> {label}
            </>
          }
        />
      )
    default:
      return <Button {...restProps} />
  }
}
